import React from 'react';
import RichText from '@components/rich-text/rich-text';
import { TwoColumnTextProps } from './two-column-text.types';
import {
  TwoColumnsWrapper,
  Column,
  TwoColumnsTextContainer,
  TwoColumnTextTitle,
  BackgroundImageWrapper,
  BackgroundColor,
  GifOrSvgImage,
} from './two-column-text.styles';
import SingleCtaBlock from '@blocks/single-cta-block/single-cta-block';
import { GatsbyImage } from 'gatsby-plugin-image';

const TwoColumnText: React.FC<TwoColumnTextProps> = ({
  title,
  leftText,
  rightText,
  backgroundColor = 'transparent',
  backgroundImage,
  mobileBackgroundImage,
  colour,
}) => {
  const resolveImage = (image: any) => {
    if (!image) return null;
    const { format, src } = image ?? {};
    const isUnsupportedType =
      format === 'image/gif' || format === 'image/svg+xml';

    return isUnsupportedType ? src : image.gatsbyImageData;
  };

  const desktopImage = resolveImage(backgroundImage);
  const mobileImage = resolveImage(mobileBackgroundImage);

  const hasDesktopBackgroundImage = !!desktopImage;
  const hasMobileBackgroundImage = !!mobileImage;

  return (
    <TwoColumnsTextContainer backgroundColor={backgroundColor} colour={colour}>
      <BackgroundColor
        backgroundColor={backgroundColor!}
        className={`
          ${hasMobileBackgroundImage ? 'hide-mobile' : ''}
          ${hasDesktopBackgroundImage ? 'hide-desktop' : ''}
        `}
      />
      {hasDesktopBackgroundImage && (
        <BackgroundImageWrapper className="desktop-only">
          {typeof desktopImage === 'string' ? (
            <GifOrSvgImage
              src={desktopImage}
              alt={backgroundImage?.alt || ''}
            />
          ) : (
            <GatsbyImage
              image={desktopImage}
              alt={backgroundImage?.alt || ''}
              objectFit="cover"
            />
          )}
        </BackgroundImageWrapper>
      )}
      {hasMobileBackgroundImage && (
        <BackgroundImageWrapper className="mobile-only">
          {typeof mobileImage === 'string' ? (
            <GifOrSvgImage
              src={mobileImage}
              alt={mobileBackgroundImage?.alt || ''}
            />
          ) : (
            <GatsbyImage
              image={mobileImage}
              alt={mobileBackgroundImage?.alt || ''}
              objectFit="cover"
            />
          )}
        </BackgroundImageWrapper>
      )}
      {title && (
        <TwoColumnTextTitle color={colour} data-testid="two-column-text-title">
          {title}
        </TwoColumnTextTitle>
      )}
      <TwoColumnsWrapper>
        <Column>
          <RichText
            content={leftText}
            extraComponents={{ SingleCta: SingleCtaBlock }}
          />
        </Column>
        <Column>
          <RichText
            content={rightText}
            extraComponents={{ SingleCta: SingleCtaBlock }}
          />
        </Column>
      </TwoColumnsWrapper>
    </TwoColumnsTextContainer>
  );
};

export default TwoColumnText;
